import { commonInsurances } from './constants'
import { isNonEmptyArray, isNonEmptyString } from '../../../utils/checks'
import { generateCommaSeparatedListEndingWithAnd } from '../../../utils/generateCommaSeparatedListEndingWithAnd'

export function filterAndJoinAcceptedInsurance(
  insurances = [],
  insuranceFacet = ''
) {
  if (!Array.isArray(insurances)) {
    return ''
  }

  if (insurances.length === 0) {
    return ''
  }

  const filteredInsurances = insurances.filter((insurance) =>
    commonInsurances.includes(insurance)
  )

  if (
    filteredInsurances.length === insurances.length &&
    filteredInsurances.length > 0
  ) {
    return (
      generateCommaSeparatedListEndingWithAnd(filteredInsurances) + ' Accepted'
    )
  }

  if (isNonEmptyString(insuranceFacet)) {
    return `${insuranceFacet} Accepted`
  }

  if (isNonEmptyArray(insuranceFacet)) {
    return `${generateCommaSeparatedListEndingWithAnd(insuranceFacet)} Accepted`
  }

  return 'Insurance Accepted'
}
